@if (hasError('required')) {
  <span>{{ required() || ('form.error.required' | transloco: { field: label }) }}</span>
}
@if (hasError('email')) {
  <span>{{ 'form.error.email' | transloco }}</span>
}
@if (hasError('min')) {
  <span>{{ 'form.error.min-value' | transloco: { field: label, expected: getError('min') } }}</span>
}
@if (hasError('minlength')) {
  <span>{{ 'form.error.min-length' | transloco: { field: label, expected: getError('minlength').requiredLength } }}</span>
}
@if (hasError('maxlength')) {
  <span>{{ 'form.error.max-length' | transloco: { field: label, expected: getError('maxlength').requiredLength } }}</span>
}
@if (hasError('serverError')) {
  <span>
    @for (error of getError('serverError'); track error) {
      <span>{{ error }}</span>
    }
  </span>
}
<ng-content />
